<template>
  <div class="custom-input">
    <v-progress-linear
      absolute
      height="2"
      v-if="loading"
      indeterminate
      style="top: -16px"
    ></v-progress-linear>
    <div
      class="text"
      ref="editable"
      :contenteditable="!disabledInput"
      v-on="listeners"
      :style="{
        color: $vuetify.theme.currentTheme.text,
        backgroundColor: 'transparent !important',
      }"
      :class="{ disabledInput: disabledInput, empty: isEmpty }"
    />
  </div>
</template>

<script>
import { debounce } from "ts-debounce";
export default {
  props: ["value", "loading", "disabledInput"],
  data() {
    return {
      debouncedFunction: debounce(this.onCommentFinished, 2000),
    };
  },
  computed: {
    listeners() {
      return { ...this.$listeners, input: this.onInput };
    },
    isEmpty() {
      try {
        return this.$refs.editable.innerText === "";
      } catch {
        return true
      }
    }
  },

  mounted() {
    this.$refs.editable.innerText = this.value;
  },
  methods: {
    onInput(e) {
      this.debouncedFunction(e.target.innerText);
    },

    onCommentFinished(finishedComment) {
      this.$emit("input", finishedComment);
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-input {
  position: relative;
  .text {
    border-bottom: 1px solid rgba(0, 0, 0, 0.5);
    min-height: 24px;
    height: min-content;
    transition: 0.3s cubic-bezier(0.075, 0.82, 0.165, 1);
    padding: 8px 0;
    outline: none;
    position: relative;

    &:focus {
      border-bottom: 2px solid #1976d2 !important;
      caret-color: #1976d2;
      padding-bottom: 7px;
      transition: 0.3s cubic-bezier(0.075, 0.82, 0.165, 1);

      &.empty {
        &::after {
          color: #1976d274;
          opacity: 1;
        }
      }
    }

    &.disabledInput {
      cursor: default;
      padding-bottom: 7px;
      border-bottom: 2px dotted rgba(0, 0, 0, 0.5);
    }

    &:empty {
      &::after {
        content: "Add comment...";
        opacity: 0.6;
        /* cursor: text; */
        pointer-events: none;
        position: absolute;
      }
    }
  }
}
</style>